import config from 'constants/apiConfig';
import axios from 'axios';
import {
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR,
} from 'constants/validation-action-types';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';

function validateRBACPermissionForActionRequest() {
  return {
    type: VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST,
  };
}

export const validateRBACPermissionForActionSuccess = (
  validateRBACPermissionForActionResult
) => ({
  type: VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS,
  payload: validateRBACPermissionForActionResult,
});

function validateRBACPermissionForActionError(error) {
  // TODO CRITICAL
  const errorMessage =
    'validateRBACPermissionForActionError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR,
  };
}

export function validateRBACPermissionForAction(group_guid) {
  return (dispatch) => {
    dispatch(validateRBACPermissionForActionRequest());
    return axios(config.apiGateway.validateRBACPermissionForAction, {
      method: 'POST',
      data: JSON.stringify({
        group_guid: group_guid,
      }),
    })
      .then((response) => {
        const validateRBACPermissionForActionResult = response.data || {};
        dispatch(
          validateRBACPermissionForActionSuccess(
            validateRBACPermissionForActionResult
          )
        );
        // toast.success('Validate RBAC Permission for Action successful', {
        //   autoClose: 2000,
        // });
        return validateRBACPermissionForActionResult;
      })
      .catch((response, error) => {
        dispatch(validateRBACPermissionForActionError(error));
        return;
      });
  };
}
